import { SWReactIcons } from "@similarweb/icons";
import { Dropdown, DropdownButton, SimpleDropdownItem } from "@similarweb/ui-components";
import { LinkButton } from "@similarweb/ui-components";
import { PureComponent } from "react";
import {
    DropdownContainer,
    TopRow,
} from "pro-features/pages/conversion/components/benchmarkOvertime/StyledComponents";
import { prettifyConversionCategory } from "app/filters/ngFilters";
import { i18nFilter } from "app/filters/i18nFilter";
import { CatDropElem } from "./StyledComponents";
import _ from "lodash";
import { SwTrack } from "app/services/SwTrack";
import { proNavigator } from "single-spa/react-app/ProNavigator";

export class ConversionQueryBar extends PureComponent<any, any> {
    private services;

    constructor(props) {
        super(props);
        this.services = {
            swNavigator: proNavigator,
        };
        this.state = this.getState();
    }

    public getState() {
        return {
            selectedCategory: this.services.swNavigator.getParams().category,
        };
    }

    public onDropDownIndustryConversionClick = (value) => {
        const { swNavigator } = this.services;
        swNavigator.go(swNavigator.current().name, {
            industry: swNavigator.getParams().industry,
            category: value.id,
        });
        SwTrack.all.trackEvent("Drop Down", "click", `category filter/${value.id}`);
        this.setState({
            selectedCategory: value.id,
        });
    };

    public onToggle = (isOpen) => {
        const event = isOpen ? "open" : "close";
        SwTrack.all.trackEvent("Drop Down", event, "category filter");
    };

    public getAvailableCategories = () => {
        const currentIndustry = this.services.swNavigator.getParams().industry;
        return Object.keys(this.services.window.similarweb.config.industries[currentIndustry]);
    };

    public getAvailableCategoriesDropItems = () => {
        const currentIndustry = this.services.swNavigator.getParams().industry;
        const availableCategories = this.getAvailableCategories();
        return [
            <DropdownButton
                key={"channel-button"}
                width={340}
            >
                <b>{prettifyConversionCategory(currentIndustry, this.state.selectedCategory)}</b>
            </DropdownButton>,
            ..._.map(availableCategories, (category: string) => {
                const prettyCat = prettifyConversionCategory(currentIndustry, category);
                return (
                    <SimpleDropdownItem
                        key={category}
                        id={category}
                    >
                        <CatDropElem title={prettyCat}>{prettyCat}</CatDropElem>
                    </SimpleDropdownItem>
                );
            }),
        ];
    };

    public render() {
        const props = {
            maxWidth: "250px",
            selectedCat: this.state.selectedCategory,
            trackName: "Header/Category Filter",
            minWidth: "200px",
        };
        const homepageLink = this.services.swNavigator.href("conversion-homepage", {});

        return (
            <TopRow>
                <LinkButton
                    url={homepageLink}
                    label={i18nFilter()("conversion.buyer.journey")}
                />
                <SWReactIcons
                    iconName="chev-right"
                    size="xs"
                />
                <DropdownContainer style={{ width: "340px" }}>
                    <Dropdown
                        dropdownPopupPlacement={"bottom-left"}
                        selectedIds={{ [this.state.selectedCategory]: true }}
                        shouldScrollToSelected={true}
                        onToggle={this.onToggle}
                        onClick={this.onDropDownIndustryConversionClick}
                    >
                        {this.getAvailableCategoriesDropItems()}
                    </Dropdown>
                </DropdownContainer>
            </TopRow>
        );
    }
}
